export type ResizeProps = { isCollapsed: boolean; width: number };
export type SidebarContent = { type: Cards; content: React.ReactNode };
export type CollapsedContentProps = { id: string; tabIndex: number };

export type ExpanderOnChangeEvent = { isCollapsed: boolean };

// Safari doesn't support `buttons` property that contains bitmask of pressed mouse buttons.
// Instead it provides `which` property that fits to our needs.
export type ExtendedMouseEvent = MouseEvent & {
  which: number | null | undefined;
};

/**
 * IMPORTANT!
 * The BBC Kodak team has rolled out the new PR layout to 100% of users but FF still needs cleanup.
 * If you are adding something to this file, you need to add it to the new tabbed layout as well. Reach
 * out to design or in #bbc-ia-changes if you do not have designs for your addition in the new layout.
 * Please make sure someone on the Kodak team is included on any
 * PR reviews that touch this file.
 * (Note: remove this comment when pr-review-info-arch-changes FF is cleaned up - COREX-8577)
 */

export enum Cards {
  ReviewerStatuses = 'ReviewerStatuses',
  BuildStatus = 'BuildStatus',
  PRList = 'PRList',
  FileTree = 'FileTree',
  Tasks = 'Tasks',
  JiraIssues = 'JiraIssues',
  CodeInsights = 'CodeInsights',
  ConnectPullRequest = 'ConnectPullRequest',
  GpgKeyVerification = 'GpgKeyVerification',
  Activities = 'Activites',
  Feedback = 'Feedback',
  NewUser = 'NewUser',
  Discovery = 'Discovery',
  SourceDetails = 'SourceDetails',
  ConnectSource = 'ConnectSource',
  ForgeRepoPullRequestCard = 'ForgeRepoPullRequestCard',
  CompassCard = 'CompassCard',
  ForgeRepoCodeOverviewCard = 'ForgeRepoCodeOverviewCard',
  CommitCard = 'CommitCard',
  Pipelines = 'Pipelines',
  MergeChecksCard = 'MergeChecksCard',
  PipelinesMetricCard = 'PipelinesMetricCard',
  PipelinesMetricsGroupLabel = 'PipelinesMetricsGroupLabel',
  PipelinesMetricsGroupSelectLabel = 'PipelinesMetricsGroupSelectLabel',
}
